import { api } from './client';

export interface TenantPortalUser {
  id: string;
  email: string;
  name: string;
  status: string;
  isProtected: boolean;
  userKind: string;
  createdAt: string;
  updatedAt?: string;
  roles: Array<{ role: { id: string; name: string; scope?: string } }>;
}

export const usersApi = {
  list: () => api.get<TenantPortalUser[]>('/api/users'),

  create: (body: {
    email: string;
    password: string;
    name?: string;
    roleId?: string;
  }) => api.post<TenantPortalUser>('/api/users', body),

  update: (id: string, body: { name?: string; status?: string }) =>
    api.patch<TenantPortalUser>(`/api/users/${id}`, body),

  setRole: (id: string, roleId: string) =>
    api.patch<TenantPortalUser>(`/api/users/${id}/role`, { roleId }),

  delete: (id: string) => api.delete<{ success: boolean }>(`/api/users/${id}`),
};
